<div class="pie-chart">
  @if (dataset()?.data?.length) {
    <highcharts-chart
      class="highcharts-light"
      [options]="chartOptions()"
    />
  } @else {
    <div class="pie-chart__no-data">No data available.</div>
  }
</div>
